// C:\Ava_Local\Ava_API\avaai_dashboard\frontend\src\pages\education\FunctionsPage.tsx
import React from "react";
import TutorPage from "./TutorPage";

export default function FunctionsPage() {
  return <TutorPage initialTopic="Functions" lockTopic />;
}